module.exports = __webpack_public_path__ + "static/media/Niveau_elN15_2_953615.d2640fd0.png";